@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../../constants/spacing.module.less';

.title {
  color: var(--grey-900);
}

.title-wrapper {
  align-items: baseline;
}

.tax-id-container {
  padding: @space-4 @space-8;
  background-color: var(--grey-200);
  border-radius: @space-4;
}
